import React, { useEffect, useState } from 'react';
import { getHistory, clearHistory, formatDate, type HistoryRecord } from '../ivansMonitorService';

const SHOWN = 5;

interface Props {
  onOpenSchedule: () => void;
}

const RecentReports: React.FC<Props> = ({ onOpenSchedule }) => {
  const [records, setRecords] = useState<HistoryRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  const load = async () => {
    setRecords(await getHistory().catch(() => []));
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const handleClear = async () => {
    await clearHistory();
    setShowAll(false);
    await load();
  };

  const visible = showAll ? records : records.slice(0, SHOWN);

  return (
    <div className="ivm-section">
      <div className="ivm-section__header">
        <div className="ivm-section__title">Recent reports</div>
        <div className="ivm-section__links">
          <button type="button" className="ivm-subtle-link" onClick={onOpenSchedule}>Update schedule</button>
          {records.length > 0 && (
            <button type="button" className="ivm-subtle-link" onClick={handleClear}>Clear history</button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="ca-empty">Loading…</div>
      ) : records.length === 0 ? (
        <div className="ca-empty">No alerts yet. Reports from scheduled and manual checks show up here.</div>
      ) : (
        <>
          <table className="ca-run__table">
            <thead>
              <tr>
                <th>Alerted At (UTC)</th>
                <th>Carrier</th>
                <th>Agency</th>
                <th>Class Code</th>
                <th>File</th>
              </tr>
            </thead>
            <tbody>
              {visible.map((r, i) => (
                <tr key={`${r.fileId}-${i}`}>
                  <td>{formatDate(r.alertedAt)}</td>
                  <td>{r.carrier || '(unknown)'}</td>
                  <td>{r.agencyName}</td>
                  <td>{String(r.classCode ?? '')}</td>
                  <td>{r.fileId.split('|')[0]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {records.length > SHOWN && (
            <button type="button" className="ivm-subtle-link" onClick={() => setShowAll((v) => !v)}>
              {showAll ? 'Show fewer' : `Show all ${records.length}`}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default RecentReports;
